import top1 from '../Images/top1.png';
import top2 from '../Images/top2.png';
import img1 from '../Images/top1.png'
import img2 from '../Images/top2.png';
import work from '../Images/phones.png'
import lady from '../Images/ladies.png';
import nocode from '../Images/no.jpeg';
import techup from '../Images/techup.webp';
import iconpark from '../Images/icon-park_graphic-design-two.png';
import flat from '../Images/flat-color-icons_engineering.png';
import icon from '../Images/icon-park_data-all.png'





export const TopTalents = [
    {
        id:1,
        img:top1,
        name:'Sharon Uzu',
        track:'Front-end Developer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },

    {
        id:2,
        img:top2,
        name:'Tonia John',
        track:'Digital Marketer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },

    {
        id:3,
        img:top1,
        name:'Lolia Nnodim',
        track:'Product Designer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },

    {
        id:4,
        img:top2,
        name:'Adaeze Chuma',
        track:'Product Manager',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },


    {
        id:5,
        img:top1,
        name:'Joy John',
        track:'Content Writer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },


    {
        id:6,
        img:top2,
        name:'Chisom Eze',
        track:'Digital Marketer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },


    {
        id:7,
        img:top1,
        name:'Love Chizi',
        track:'Back-end Developer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    },


    {
        id:8,
        img:top2,
        name:'Chioma John',
        track:'Graphic Designer',
        text:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolorem minima impedit fugit dignissim.',
        fb:'https://facebook.com',
        twitter:'https://twitter.com',
        Inst:'https://instagram.com',
    }
]





export const FindTalents = [

    {
        id: 1,
        img:img1,
        name: 'Chisom Eze',
        price: '$15 / hr',
        track:'Digital Marketer',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },
    {
        id: 2,
        img:img2,
        name: 'Lolia A.',
        price: '$15 / hr',
        track:'Product Designer',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },
    {
        id: 3,
        img:img2,
        name: 'Chioma John',
        price: '$17 / hr',
        track:'Digital Marketer',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },
    {
        id: 4,
        img:img1,
        name: 'Sharon U',
        price: '$30 / hr',
        track:'Frontend Developer',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },

    {
        id: 5,
        img:img1,
        name: 'Blessing Z.',
        price: '$25 / hr',
        track:'Digital Marketer',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },
    {
        id: 4,
        img:img2,
        name: 'Loveth B.',
        price: '$10 / hr',
        track:'Data Analyst',
        text:"Scopic offers high-quality and affordable web development and design services, providing customized solutions that best fit your business's unique needs. Having over 14 years of experience in the soft…",
        portfolio:'',
        workpix: work,
        fb:'https://www.facebook.com',
        twitter:'https://twitter.com',
        ins: 'https://www.instagram.com',
    },
    
]

export const Event = [
    {
        bg:lady,
        title:'Ladies Can Tech',
        text: 'Coming Soon',
    },
    {
        bg:nocode,
        title:'NoCodeFest',
        text: 'Coming Soon',
    },
    {
        bg:techup,
        title:'TechUp PH',
        text: 'Coming Soon',
    }
]


export const FindJobs = [
    {
        id: '1',
        img: iconpark,
        role:'Graphic Designer',
        company:'Thirdspace',
        stack: 'Graphics Design',
        type:'Full time'
    },
    {
        id:'2',
        img: flat,
        role:'Full Stack JS Developer',
        company:'Scopia',
        stack: 'Developer',
        type:'Remote'
    },
    {
        id:'3',
        img: icon,
        role:'Data Analyst',
        company:'Eco',
        stack: 'IT',
        type:'Part time'
    },
    {
        id: '4',
        img: iconpark,
        role:'Graphic Designer',
        company:'Thirdspace',
        stack: 'Graphics Design',
        type:'Full time'
    },
    {
        id:'5',
        img: flat,
        role:'Full Stack JS Developer',
        company:'Scopia',
        stack: 'Developer',
        type:'Remote'
    },
    {
        id:'6',
        img: icon,
        role:'Data Analyst',
        company:'Eco',
        stack: 'IT',
        type:'Part time'
    },
    {
        id: '7',
        img: iconpark,
        role:'Graphic Designer',
        company:'Thirdspace',
        stack: 'Graphics Design',
        type:'Full time'
    },
    {
        id:'8',
        img: flat,
        role:'Full Stack JS Developer',
        company:'Scopia',
        stack: 'Developer',
        type:'Remote'
    },
    {
        id:'9',
        img: icon,
        role:'Data Analyst',
        company:'Eco',
        stack: 'IT',
        type:'Part time'
    },
    {
        id: '10',
        img: iconpark,
        role:'Graphic Designer',
        company:'Thirdspace',
        stack: 'Graphics Design',
        type:'Full time'
    },
    {
        id:'11',
        img: flat,
        role:'Full Stack JS Developer',
        company:'Scopia',
        stack: 'Developer',
        type:'Remote'
    },
    {
        id:'12',
        img: icon,
        role:'Data Analyst',
        company:'Eco',
        stack: 'IT',
        type:'Part time'
    },
]